<template>
    <br>
    <div id="service-multiple" class="one-service-area ptb-100">
        <div class="container">
            <div class="one-section-title">
                <span class="sub-title">{{ subTitle }}</span>
                <h2>{{ heading }}</h2>
            </div>

            <div class="tabs-layout">

                <!-- Sidebar -->
                <nav class="tabs">
                    <div class="tabs__header">
                        <a 
                            class="tabs__header-item" 
                            v-for="tab in tabs" 
                            v-on:click="selectTab(tab.id)" 
                            :class="{ 'active': activeTab == tab.id }"
                            :key="tab.id"
                        >
                            <div class="service-item">
                                <i :class="tab.icon"></i>
                                <span>{{ $t(tab.name) }}</span>
                            </div>
                        </a>
                    </div>
                </nav>

                <!-- Contenido -->
                <div class="tabs__container tabs__container--center">
                    <div class="tabs__list" ref="tabsList">
                        <div 
                            class="tabs__list-tab"
                            v-for="tab in tabs"
                            :class="{ 'active': activeTab == tab.id }"
                            :key="tab.id"
                        >
                            <div class="service-advisor">
                                <div class="row align-items-center">
                                    <div class="col-lg-6">
                                        <div class="advisor-img">
                                            <img :src="tab.image" alt="web">
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="advisor-content">
                                            <h2>{{ $t(tab.title) }}</h2>
                                            <p>{{ $t(tab.shortDesc) }}</p>
                                            <ul>
                                                <li v-for="list in tab.lists" :key="list.id">
                                                    <i :class="list.icon"></i>
                                                    {{ $t(list.text) }}
                                                </li>
                                            </ul>
                                            <div class="advisor-link">
                                                <a href="https://wa.me/34634061655?text=Hola,%20quiero%20información%20sobre%20vuestros%20servicios" target="_blank">
                                                    {{ $t('packs.cta') }}
                                                </a>
                                                <i class="bx bx-right-arrow-alt"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'OurCoreService',
    props: ['subTitle', 'heading'],
    data () {
        return {
            activeTab: 1,
            offsetRight: 0,
            
            tabs: [
{
    id: 1,
    icon: 'bx bx-layout',
    name: 'packs.basic.name',
    image: require('../../assets/img/resources/web-basico.png'),
    title: 'packs.basic.title',
    shortDesc: 'packs.basic.desc',
    lists: [
        { id: 1, icon: 'bx bxs-chevrons-right', text: 'packs.basic.l1' },
        { id: 2, icon: 'bx bxs-chevrons-right', text: 'packs.basic.l2' },
        { id: 3, icon: 'bx bxs-chevrons-right', text: 'packs.basic.l3' },
        { id: 4, icon: 'bx bxs-chevrons-right', text: 'packs.basic.l4' },
        { id: 5, icon: 'bx bxs-chevrons-right', text: 'packs.basic.l5' },
        { id: 6, icon: 'bx bxs-chevrons-right', text: 'packs.basic.l6' }
    ]
},
{
    id: 2,
    icon: 'bx bx-window-alt',
    name: 'packs.pro.name',
    image: require('../../assets/img/resources/web-premium.png'),
    title: 'packs.pro.title',
    shortDesc: 'packs.pro.desc',
    lists: [
        { id: 1, icon: 'bx bxs-chevrons-right', text: 'packs.pro.l1' },
        { id: 2, icon: 'bx bxs-chevrons-right', text: 'packs.pro.l2' },
        { id: 3, icon: 'bx bxs-chevrons-right', text: 'packs.pro.l3' },
        { id: 4, icon: 'bx bxs-chevrons-right', text: 'packs.pro.l4' },
        { id: 5, icon: 'bx bxs-chevrons-right', text: 'packs.pro.l5' },
        { id: 6, icon: 'bx bxs-chevrons-right', text: 'packs.pro.l6' }
    ]
},
{
    id: 3,
    icon: 'bx bx-edit-alt',
    name: 'packs.custom.name',
    image: require('../../assets/img/resources/web-personalizado.png'),
    title: 'packs.custom.title',
    shortDesc: 'packs.custom.desc',
    lists: [
        { id: 1, icon: 'bx bxs-chevrons-right', text: 'packs.custom.l1' },
        { id: 2, icon: 'bx bxs-chevrons-right', text: 'packs.custom.l2' },
        { id: 3, icon: 'bx bxs-chevrons-right', text: 'packs.custom.l3' },
        { id: 4, icon: 'bx bxs-chevrons-right', text: 'packs.custom.l4' },
        { id: 5, icon: 'bx bxs-chevrons-right', text: 'packs.custom.l5' },
        { id: 6, icon: 'bx bxs-chevrons-right', text: 'packs.custom.l6' }
    ]
}
]
        }
    },
    methods: {
        selectTab (id) {
            const tabsList = this.$refs.tabsList
            this.activeTab = id
            this.offsetRight = tabsList.clientWidth * (id - 1)
            tabsList.style.right = this.offsetRight + 'px'
        }
    }
}
</script>

<style scoped>
/* ===============================
   Bloque de pestañas centradas
   =============================== */

/* Contenedor de tabs centrado y con columnas iguales */
.tabs__header {
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 280px)); /* botones iguales */
  gap: 1rem;
  justify-content: center;    /* 🔹 centra el grupo de botones */
  align-items: center;
  margin: 0 auto 2rem;        /* centrado + espacio inferior */
  width: 100%;
}

/* Cada enlace ocupa toda su celda */
.tabs__header-item {
  display: block;
  text-decoration: none;
  width: 100%;
}

/* Botón */
.service-item {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 16px 18px;
  border-radius: 10px;
  transition: all 0.3s ease;
}

/* Estado activo */
.tabs__header-item.active .service-item {
  background: var(--main-color, #d35400);
  color: #fff;
}

/* Estado inactivo */
.tabs__header-item:not(.active) .service-item {
  background: #f4f4f4;
  color: #333;
}

/* Hover */
.tabs__header-item:hover .service-item {
  opacity: 0.9;
}

/* Responsive: en móviles apila verticalmente */
@media (max-width: 600px) {
  .tabs__header {
    grid-template-columns: 1fr;
    max-width: 360px;
    justify-content: center;
  }
}

/* ===============================
   Contenido del bloque general
   =============================== */

.tabs__container--center {
  max-width: 1100px;
  margin: 0 auto;
}

.one-section-title {
  text-align: center;
}

.one-section-title h2 {
  margin-bottom: 2rem;
}

/* Estilo del enlace dentro de cada pestaña */
.advisor-link a {
  color: var(--main-color, #d35400);
  font-weight: bold;
  text-decoration: none;
}
/* ====== Fix centrado y ancho ESTABLE SOLO en tablet (768–1199px) ====== */
@media (min-width: 768px) and (max-width: 1199px) {
  /* Centra el contenedor de tabs dentro del .container */
  .tabs {
    display: flex;
    justify-content: center;
  }

  /* 2 columnas fijas y centradas, sin permitir encogimiento */
  .tabs__header {
    display: grid;
    grid-template-columns: repeat(2, 280px);   /* ancho fijo por botón */
    gap: 1rem;
    justify-content: center;                   /* centra el grupo */
    margin-left: auto;
    margin-right: auto;
    max-width: calc(560px + 1rem);             /* 2×280 + gap */
  }

  /* Evita que el contenido se “aplane” en puntos intermedios */
  .tabs__header-item,
  .tabs__header-item .service-item {
    min-width: 280px;      /* coincide con la columna */
    flex: 0 0 auto;        /* no encoge en ningún caso */
  }
}


</style>
